const formText = {
    ru: {
        formHeader: "Оставить заявку",
        name: "ФИО",
        phone: "Номер",
        mail: "Электронная почта",
        comment: "Комментарий",
        confidatial: `<p>Нажимая на кнопку вы <a target="_blank" href="/uploads/+Пользовательское%20соглашение.pdf">соглашаетесь</a> с <a target="_blank" href="/uploads/Политика конфиденциальности.pdf" target="_blank">политикой <br> конфиденциальности</a> и <a target="_blank" href="/uploads/+3_согласие_создание_маркетинговые_рассылки.pdf">рассылкой</a> и даёте <a target="_blank" href="/uploads/+1_согласие_оставление_информации_на_сайте_2.pdf">согласие </a>на обработку персональных данных</p>`,
        submit: "Отправить"
    },
    eng: {
        formHeader: "Get in touch",
        name: "Name",
        phone: "Phone number",
        mail: "E-mail",
        comment: "Message",
        confidatial: "Yes, I give my consent to the processing of my personal data and the use of e-mail communications - in accordance with the Privacy Policy - to process and respond to this request.",
        submit: "Send"
    },
    az: {
        formHeader: "Müraciət et",
        name: "Ad, Soyad",
        phone: "Əlaqə nömrəsi",
        mail: "E-mail",
        comment: "Qeyd",
        submit: "Göndər",
        confidatial: "Düyməni sıxmaqla siz Məxfilik Siyasəti ilə və göndərişlərin alınması ilə razılaşır, həmçinin şəxsi məlumatlarınızın emalına razılıq verirsiniz.",

    }
}

export default formText